export default "/_next/static/images/service-wellness-desktop-3x-48d9c673607bb411b1746ad10609f997.jpg";